import { SupportedCurrencies, displayMoney } from 'gmd-utilities-package';
import { BalanceInfo, CurrencyData } from '../types';

export const getBalanceInfo = (currencyData: CurrencyData): BalanceInfo => {
  const currencyInfo = SupportedCurrencies[currencyData.name.toUpperCase()];
  const currencyCode = currencyInfo.currencyCode;
  let item: BalanceInfo = {
    title: currencyInfo.displayLabel,
    amount: displayMoney(currencyData.value, currencyData.name, true),
    currency: currencyData.name,
    symbol: currencyCode,
  };
  return item;
};

export const convertBalance = (
  currencyData: CurrencyData
): BalanceInfo | null => {
  //find the first supported currency with intlabel of this
  const currencies = Object.keys(SupportedCurrencies);
  const intLabel = currencyData.name.toUpperCase();
  let balanceCurrency;
  let item: BalanceInfo;

  for (const currency of currencies) {
    const supportedCurrency = SupportedCurrencies[currency];
    if (
      supportedCurrency &&
      supportedCurrency.intLabel.toUpperCase() ===
        currencyData.name.toUpperCase()
    ) {
      balanceCurrency = currency;
      break;
    }
  }
  if (balanceCurrency) {
    const supportedCurrency = SupportedCurrencies[balanceCurrency];
    item = {
      title: `${currencyData.label} - ${intLabel}`,
      amount: displayMoney(currencyData.value, balanceCurrency, true),
      currency: currencyData.name,
      symbol: supportedCurrency.intLabel.toUpperCase(),
    };
    return item;
  }

  return null;
};

export const convertBalances = (
  currencyData: CurrencyData[]
): BalanceInfo[] => {
  let result: BalanceInfo[] = [];
  const balances = currencyData.map(convertBalance);
  balances.forEach((x) => {
    if (x) {
      result.push(x);
    }
  });
  return result;
};
